module.exports = __webpack_public_path__ + "e995322edc4aa2749ed9d34a21be69da.svg";